import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';


@Component({
  selector: 'app-group-table',
  templateUrl: './group-table.component.html',
  styleUrls: ['./group-table.component.sass']
})
export class GroupTableComponent extends BaseListDirective {

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'FORM.NAME', 300, { frozen: true }),
    new PrimeNGTableColumn('description_', 'FORM.DESCRIPTION', 100)
  ];
  override title = 'CORE.GROUP';
  override filterableFields = []
  override keys = {
    primary_key: 'user_group_id',
    label: 'name_'
  }
  override filename = 'CORE.GROUP';

  override getList(): void {
    this.query(this.data.core.groups()).subscribe()
  }

  override handleRows(data: any): void {
    console.log(data);
    super.handleRows(data);
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.groupDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }
}
